// @flow
import React, {useEffect, useState} from 'react';
import {useQuery} from '@apollo/react-hooks';
import {connect} from 'react-redux';
import {compose} from 'redux';
import Experiment, {On} from '@homeaway/react-experiment';
import {VRBO_RECENTLY_VIEWED_SERP_CAROUSEL} from '../../abacus/experiments';
import PropertyCarousel from '../PropertyCarousel/PropertyCarousel';
import {triggerPresentedSerpRecentlyViewedCarouselEvent} from '../../utils/collectionEdapUtils';
import withLingua from '../withLingua/withLingua';
import type {LinguaProps} from '../withLingua/withLingua';
import transformReduxParamsToSearch from '../../queries/transformReduxParamsToSearchRequest';
import previouslyViewedSearchQuery from './previouslyViewedSearchQuery';
import filterNonDisplayableListings from './utils/filterNonDisplayableListings';
import type {ParsedSearchParams} from '../../queries/searchRequestQuery';
import {media} from '../../utils/breakpoints';
import {DESKTOP_BREAKPOINTS, MOBILE_BREAKPOINTS} from './breakpoints';
import {
    CARDS_MIN_LIMIT,
    DESKTOP_CARDS_MAX_LIMIT,
    MOBILE_CARDS_MAX_LIMIT
} from './constants';

import './RecentlyViewedCarousel.less';

type OwnProps = {
    isMobile: boolean,
    messages: any,
    parsedParams: ParsedSearchParams,
    checkIn: string
};

type Props = OwnProps & LinguaProps;

export const RecentlyViewedCarousel = (props: Props) => {
    const {isMobile, messages, parsedParams, checkIn} = props;
    const title = messages.recentlyViewed;
    const [breakpoints, pageSize] = isMobile
        ? [MOBILE_BREAKPOINTS, MOBILE_CARDS_MAX_LIMIT]
        : [DESKTOP_BREAKPOINTS, DESKTOP_CARDS_MAX_LIMIT];

    const {data, error} = useQuery(previouslyViewedSearchQuery, {
        variables: {
            request: {
                ...parsedParams,
                paging: {
                    page: 1,
                    pageSize
                }
            }
        }
    });

    const [listings, setListings] = useState([]);

    useEffect(() => {
        if (data && data.previouslyViewedSearch) {
            setListings(filterNonDisplayableListings(data));
            if (listings.length >= CARDS_MIN_LIMIT) {
                triggerPresentedSerpRecentlyViewedCarouselEvent();
            }
        }
    }, [data, listings.length]);

    if (error || !data || !data.previouslyViewedSearch) {
        return null;
    }

    if (listings.length < CARDS_MIN_LIMIT) {
        return null;
    }

    return (
        <Experiment name={VRBO_RECENTLY_VIEWED_SERP_CAROUSEL}>
            <On>
                <PropertyCarousel
                    isMobile={isMobile}
                    title={title}
                    breakpoints={breakpoints}
                    listings={listings}
                    checkIn={checkIn}
                />
            </On>
        </Experiment>
    );
};

const mapStateToProps = (state) => {
    const {viewport, searchParams} = state;
    const {params} = searchParams;
    const checkIn = searchParams.params.arrival;
    const breakpoint = viewport.breakpoint;
    const isMobile = !media(breakpoint, {minWidth: 'SM_MIN'});
    const parsedParams = transformReduxParamsToSearch(params);

    return {
        isMobile,
        parsedParams,
        checkIn
    };
};

export default compose(
    connect(mapStateToProps),
    withLingua({
        namespace: 'traveler/search',
        category: 'messages'
    })
)(RecentlyViewedCarousel);
